/* eslint-disable react/prop-types */
// @ts-nocheck
import { Button, Card, withStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import CardIcon from '@material-ui/icons/CreditCard';
import InvitationsIcon from '@material-ui/icons/InsertLink';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import LaunchIcon from '@material-ui/icons/Launch';
import LockIcon from '@material-ui/icons/LockOpen';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ReactTooltip from 'react-tooltip';
import { submit } from 'redux-form';
import { BLUE, GREEN, LICENSE_TYPES, ORANGE, PERMISSION_ENTITIES, RED } from '../../_config/consts';
import { formatWalletSubscriptionsToReadableEntity, getColorFromThemeName, getIconFromSubscriptionResource, getLicenseName, hasFormWritePermission } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import * as CloudCreditsActions from '../../redux/actions/cloudCredits.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import CreditsIconCustom from '../CustomIcons/CreditsIconCustom.jsx';
import UsersIconCustom from '../CustomIcons/UsersIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import OperationalView from '../OperationalView/OperationalView.jsx';
import ChangeTierForm from '../forms/CloudCredits/ChangeTierForm.jsx';
import MainSubscriptionCounter from './MainSubscriptionCounter.jsx';
import WalletSubscriptionRemoveView from './WalletSubscriptionRemoveView.jsx';
import DeleteOutlineIconCustom from '../CustomIcons/DeleteOutlineIconCustom.jsx';

const styles = {
  container: {
    paddingTop: 0,
    borderRadius: 10,
    marginTop: 5,
    paddingBottom: 10,
    width: '100%',
  },
  subscriptionContainer: {
    padding: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    width: 'fit-content',
    marginRight: 40,
    paddingLeft: 15,
  },
  tableCard: {
    margin: 20,
    borderRadius: 10,
    width: 'calc(100% - 40px)',
    overflow: 'hidden',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
  },
  tableColumnText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  cardTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20,
  },
  boldText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  subscriptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    margin: 20,
    padding: 3,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 20,
  },
  cardInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    width: '100%'
  },
  consumptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 15,
  },
  consumptionText: {
    color: ORANGE,
    margin: 0,
  },
  licenseContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 20
  },
  mainTierLimitContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  subSubscriptionContainer: {
    padding: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    minWidth: 320,
    marginRight: 40,
    paddingLeft: 15,
  },
  button: {
    color: RED,
    fontSize: 12,
  },
};

const SubscriptionCard = ({ subscription, onRemoveSubscription, classes }) => {
  const icon = getIconFromSubscriptionResource(subscription.resource);
  if (!subscription) return null;
  const subcriptionFormatted = formatWalletSubscriptionsToReadableEntity(subscription);
  return (
    <Card className={classes.subSubscriptionContainer}>
      <div className={classes.cardInnerContainer}>
        {icon}
        <div style={{ marginLeft: 20 }}>
          <h4 className={classes.boldText}>{subcriptionFormatted.friendlyName}</h4>
          <div className={classes.consumptionContainer}>
            <CreditsIconCustom style={{ color: ORANGE, width: 20, marginRight: 5 }} />
            <h4 className={classes.consumptionText}>
              <Entity entity="walletCreditsConsumptionText" data={{ credits: subscription.burnRate }} />
            </h4>
          </div>
          {subscription.canBeDeactivated ? (
            <MDButton
              key={subscription.id}
              title={<Entity entity="removeSubscription" />}
              containerStyle={{ margin: 0, marginTop: 10 }}
              titleStyle={{ fontSize: 12, fontWeight: 'bold' }}
              backgroundColor={RED}
              style={{ marginTop: 5, height: 15 }}
              onClick={() => onRemoveSubscription()}
            />
          ) : null}
        </div>
      </div>
    </Card>
  );
};

const MainLicenseCard = ({ subscription, walletInfo, isLuckeyLite, classes, onUpgradeTierRequest }) => {
  if (!subscription) return null;
  const icon = getIconFromSubscriptionResource(subscription.resource);
  const numberOfUsers = walletInfo && walletInfo.numOfUsers ? walletInfo.numOfUsers : 0;
  const numberOfLocks = walletInfo && walletInfo.numOfLocks ? walletInfo.numOfLocks : 0;
  const numberOfInvitations= walletInfo && walletInfo.numOfInvitations ? walletInfo.numOfInvitations : 0;
  const numberOfExtraCredentials = walletInfo && walletInfo.numOfExtraCredentials ? walletInfo.numOfExtraCredentials : 0;
  const numberOfElements = numberOfUsers + numberOfLocks + numberOfInvitations + numberOfExtraCredentials;
  const licenseName = getLicenseName([subscription]);
  return (
    <Card className={classes.subscriptionContainer} style={{ borderLeft: `4px solid ${GREEN}`, paddingRight: 40, width: '97%' }}>
      <div className={classes.cardInnerContainer}>
        {icon}
        <div style={{ marginLeft: 10, width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <h3 className={classes.boldText}>{licenseName}</h3>
            {subscription.maxUsers ? (
                <h3 className={classes.boldText} style={{ marginLeft: 5 }}> - <Entity entity="upTo" /> {subscription.maxUsers} <Entity entity="users" /></h3>
              ) : null}
            {subscription.maxLocks ? (
                <h3 className={classes.boldText} style={{ marginLeft: 5 }}> - <Entity entity="upTo" /> {subscription.maxLocks} <Entity entity="locks" /></h3>
              ) : null}
            {subscription.maxElements ? (
                <h3 className={classes.boldText} style={{ marginLeft: 5 }}> - <Entity entity="upToTotalElements" data={{ elements: subscription.maxElements }} /></h3>
              ) : null}
          </div>
          <div className={classes.consumptionContainer}>
            <h4 className={classes.consumptionText}><Entity entity="monthlyBurnRateSubscription" />:</h4>
            <CreditsIconCustom style={{ color: ORANGE, width: 20, marginRight: 5, marginLeft: 5 }} />
            <h4 className={classes.consumptionText}>
              <Entity entity="walletCreditsConsumptionText" data={{ credits: subscription.burnRate }} />
            </h4>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 15 }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 20 }}>
              <UsersIconCustom style={{ width: 20, marginRight: 5, color: '#3f3f3f' }} />
              <h3 style={{ margin: 0, color: '#3f3f3f', fontSize: 18 }}><Entity entity="users" />: {walletInfo.numOfUsers}</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 20 }}>
              <LockIcon style={{ fontSize: 18, marginRight: 5, marginBottom: 2, color: '#3f3f3f' }} />
              <h3 style={{ margin: 0, color: '#3f3f3f', fontSize: 18 }}><Entity entity="locks" />: {walletInfo.numOfLocks}</h3>
            </div>
            {walletInfo.numOfExtraCredentials > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 20  }}>
                <CardIcon style={{ fontSize: 18, marginRight: 5, marginTop: 1, color: '#3f3f3f' }} />
                <h3 style={{ margin: 0, color: '#3f3f3f', fontSize: 18 }}><Entity entity="extraCredentials" />: {walletInfo.numOfExtraCredentials}</h3>
              </div>
            ) : null}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <InvitationsIcon style={{ fontSize: 18, marginRight: 5, marginTop: 1, color: '#3f3f3f' }} />
              <h3 style={{ margin: 0, color: '#3f3f3f', fontSize: 18 }}><Entity entity="activeInvitations" />: {walletInfo.numOfInvitations}</h3>
            </div>
          </div>
          <div className={classes.mainTierLimitContainer}>
            {subscription.maxUsers ? (
              <MainSubscriptionCounter
                used={numberOfUsers}
                max={subscription.maxUsers}
                title={<Entity entity="activeUsers" />}
              />
            ) : null}
            {subscription.maxLocks ? (
              <MainSubscriptionCounter
                used={numberOfLocks}
                max={subscription.maxLocks}
                title={<Entity entity="installedLocks" />}
              />
              ) : null}
            {subscription.maxElements ? (
              <MainSubscriptionCounter
                used={numberOfElements}
                max={subscription.maxElements}
                title={<Entity entity="elements" />}
              />
              ) : null}
            <MDButton
              key={subscription.id}
              title={<Entity entity="changeMainSubscription" />}
              containerStyle={{ margin: 0, marginTop: 20 }}
              titleStyle={{ fontSize: 12, fontWeight: 'bold' }}
              backgroundColor={BLUE}
              style={{ marginTop: 5, height: 15 }}
              onClick={() => onUpgradeTierRequest()}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

@connect(state => ({ subscriptions: state.cloudCredits.wallet.subscriptions, walletInfo: state.cloudCredits.wallet.info, viewLoading: state.utils.viewLoading, themeName: state.settings.items.theme.data.themeName }))
class WalletSubscriptionsSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isSelectTierFormOpen: false,
      availableTiers: [],
    }
  }

  onExploreMarketplace() {
    const { dispatch } = this.props;
    dispatch(push('/luckeyStore'));
  }

  onRemoveSubscriptionRequest(item) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONTENT_MODAL',
      modalProps: {
        title: <Entity entity="deleteSubscriptionRequest" />,
        content: <WalletSubscriptionRemoveView onRemoveSubscriptionConfirm={feedbackText => this.onRemoveSubscriptionConfirm(item, feedbackText)} />,
        modalStyle: { height: '90% !important' },
        onOutsideClick: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  // TO USE FOR DIRECTLY REMOVE SUBSCRIPTION USING BE
  async onRemoveSubscriptionConfirm(item, feedbackText) {
    const { dispatch, onRefreshWallet } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(CloudCreditsActions.deleteWalletSubscription(item));
      await dispatch(UserActions.fetchLicenseInfo());
      await onRefreshWallet();
      dispatch(ModalActions.hideModal());
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.hideModal());
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="removeSubscriptionError" /></h6>),
        },
      }));
    }

    if (feedbackText) {
      dispatch(CloudCreditsActions.sendRemovedSubscriptionFeedback(item.subscription, feedbackText));
    }
  }

  // // TO USE FOR OPEN A REQUEST FOR REMOVE SUBSCRIPTION
  // async onRemoveSubscriptionManualConfirm(item, feedbackText) {
  //   const { dispatch, onRefreshWallet } = this.props;
  //   try {
  //     dispatch(UtilsActions.setSpinnerVisibile(true));
  //     await dispatch(CloudCreditsActions.sendRemovedSubscriptionRequest(item.subscription, feedbackText));
  //     await dispatch(UserActions.fetchLicenseInfo());
  //     await onRefreshWallet();
  //     dispatch(ModalActions.hideModal());
  //     dispatch(UtilsActions.setSpinnerVisibile(false));
  //     dispatch(ModalActions.showModal({
  //       modalType: 'SUCCESS_ALERT',
  //       modalProps: {
  //         anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  //         message: (<h6 className="snack-title"><Entity entity="deleteSubscriptionManualRequestSuccess" /></h6>),
  //       },
  //     }));
  //   } catch (error) {
  //     dispatch(UtilsActions.setSpinnerVisibile(false));
  //     dispatch(ModalActions.hideModal());
  //     dispatch(ModalActions.showModal({
  //       modalType: 'ERROR_ALERT',
  //       modalProps: {
  //         anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  //         message: (<h6 className="snack-title"><Entity entity="removeSubscriptionError" /></h6>),
  //       },
  //     }));
  //   }
  // }

  async onUpgradeTierRequest() {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const subscriptions = await dispatch(CloudCreditsActions.fetchCloudCreditsTiers());
      this.setState({ availableTiers: subscriptions })
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isSelectTierFormOpen: true });
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async onChangeTierConfirm(values) {
    const { dispatch } = this.props;
    const { availableTiers } = this.state;
    const { selectedTier: selectedTierId } = values;
    if (selectedTierId) {
      try {
        const selectedTier = _.find(availableTiers, tier => tier.id === selectedTierId);
        dispatch(UtilsActions.setSpinnerVisibile(true));
        await dispatch(CloudCreditsActions.sendChangeTierRequest(selectedTier));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="demoRequestSuccess" /></h6>),
          },
        }));
        this.setState({ isSelectTierFormOpen: false });
      } catch (error) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="unexpectedErrorMessage" /></h6>),
          },
        }));
      }
    }
  }

  render() {
    const { subscriptions, classes, walletInfo, themeName, dispatch } = this.props;
    const { isSelectTierFormOpen, availableTiers } = this.state;
    const subscriptionsData = subscriptions && subscriptions.content;
    const textColor = getColorFromThemeName(themeName);
    const partitionedSubscriptionData = _.partition(subscriptionsData, sub => sub && sub.subscription && sub.subscription.resource === 'DOMAIN');
    const mainLicenseSubscription = partitionedSubscriptionData ? _.first(partitionedSubscriptionData[0]) : null;
    const pluginSubscriptions = partitionedSubscriptionData && partitionedSubscriptionData[1] ? partitionedSubscriptionData[1] : null;
    const isLuckeyLite = AbilityProvider.getAbilityHelper().hasLicenseType([LICENSE_TYPES.LITE]);
    return (
      <Card className={classes.container}>
        {mainLicenseSubscription && mainLicenseSubscription ? (
          <div>
            <div className={classes.headerContainer}>
              <h3 className={classes.boldText} style={{ color: textColor }}><Entity entity="yourMainSubscription" /></h3>
            </div>
            <div style={{ marginLeft: 25 }}>
              <MainLicenseCard
                subscription={mainLicenseSubscription.subscription}
                classes={classes}
                walletInfo={walletInfo}
                isLuckeyLite={isLuckeyLite}
                onUpgradeTierRequest={() => this.onUpgradeTierRequest()}
              />
            </div>
          </div>
        ) : null}
        <div style={{ marginTop: 30 }}>
          <div className={classes.headerContainer}>
            <h3 className={classes.boldText} style={{ color: textColor, marginRight: 20 }}><Entity entity="yourPlugins" /></h3>
            {pluginSubscriptions ? (
              <div style={{ marginTop: 5, display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => this.onExploreMarketplace()}>
                <h4 style={{ textAlign: 'center' }} className="link-label" ><Entity entity="exploreMarketPlace" /></h4>
                <LaunchIcon style={{ fontSize: 17, marginLeft: 5, marginTop: 2, color: '#90CAF9' }} />
              </div>
            ) : null}
          </div>
          {!pluginSubscriptions || _.isEmpty(pluginSubscriptions) ? (
            <div style={{ alignItems: 'center' }}>
              <h3 className={classes.boldText} style={{ textAlign: 'center' }}><Entity entity="noExtensionsYet" /></h3>
              <h4 style={{ marginTop: 10, color: '#3f3f3f', textAlign: 'center' }}><Entity entity="exploreMarketPlaceDescription" /></h4>
              <h4 style={{ marginTop: 5, textAlign: 'center' }} className={`link-label`} onClick={() => this.onExploreMarketplace()}><Entity entity="exploreMarketPlace" /></h4>
            </div>
          ) : (
            <Card className={classes.tableCard} elevation={3}>
              <div className={classes.tableContainer}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell><h5 className={classes.tableColumnText}><Entity entity="luckeyStoreItemTypeAddon" /></h5></TableCell>
                      <TableCell><h5 className={classes.tableColumnText}><Entity entity="consumptionRowTitle" /></h5></TableCell>
                      <TableCell><h5 className={classes.tableColumnText}><Entity entity="actions" /></h5></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {_.map(partitionedSubscriptionData[1], (subscription) => subscription.subscription.visible ? (
                      <TableRow key={subscription.subscription.id} hover>
                        <TableCell>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h4 style={{ margin: 0, marginLeft: 0, color: '#3f3f3f' }}>
                              {formatWalletSubscriptionsToReadableEntity(subscription.subscription).friendlyName}
                            </h4>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <CreditsIconCustom style={{ color: ORANGE, width: 20, marginRight: 5 }} />
                            <h4 style={{ margin: 0, color: ORANGE }}>
                              <Entity entity="walletCreditsConsumptionText" data={{ credits: subscription.subscription.burnRate }} />
                            </h4>
                          </div>
                        </TableCell>
                        <TableCell>
                          {subscription.subscription.canBeDeactivated ? (
                            <Button
                              key={subscription.subscription.id}
                              className={classes.button}
                              onClick={() => this.onRemoveSubscriptionRequest(subscription)}
                            >
                              <Entity entity="removeSubscription" />
                              <DeleteOutlineIconCustom style={{ width: 20, marginLeft: 5 }} />
                            </Button>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    ) : null)}
                  </TableBody>
                </Table>
              </div>
            </Card>
          )}
        </div>
        <ReactTooltip delayShow={200} effect="float" />
        <OperationalView
          themeName={themeName}
          isVisible={isSelectTierFormOpen}
          onClose={() => this.setState({ isSelectTierFormOpen: false })}
          operationaViewStyle={{ zIndex: 10000 }}
          style={{ margin: 0, padding: 0 }}
          title={<Entity entity="changeMainSubscription" />}
        >
          <ChangeTierForm
            tiers={availableTiers}
            onSubmit={values => this.onChangeTierConfirm(values)}
          />
          {hasFormWritePermission(PERMISSION_ENTITIES.DOMAIN_CLOUD_CREDITS, true) ? (
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('ChangeTierForm'))}
            />
          ) : null}
        </OperationalView>
      </Card>
    );
  }
}


export default withStyles(styles)(WalletSubscriptionsSection);
